import {PackedGrid} from '../CellUtils'
const r:['node',string]=['node','red']
const b:['node',string]=['node','blue']
const g:['node',string]=['node','green']
const k:['node',string]=['node','black']
const o:['node',string]=['node','orange']
const c:['node',string]=['node','cyan']
const e:[1]=[1]
export const levels:PackedGrid[]=[
    {x:3,y:1,data:[r,e,r]},
    {x:3,y:2,data:[r,e,r,b,e,b]},
    {x:3,y:3,data:[r,g,b,[3],r,g,b]},
    {x:3,y:4,data:[r,b,r,[4],b,[4]]},
    {x:3,y:3,data:[r,[7],r]},
    
    {x:5,y:5,data:[b,[2],r,o,[3],k,[3],k,[3],r,o,e,g,e,b,g,[2]]},
    {x:6,y:6,data:[g,o,[3],b,[5],r,[2],b,r,g,[5],o,[2],k,[2],k,[7]]},
    //{x:7,y:7,data:[[6],c,[5],o,r,e,o,[7],g,c,[4],g,e,k,[6],r,k,[6],b,c,e]}, //unsolvable 
]